import plangridTrackEvents from "./amplitudeInit-vanilla";

const getSidenavBlocks = () =>
  document.querySelectorAll(".webinars-sidenav-block");
const getSidenavNav = () => document.querySelector(".webinars-sidenav-nav");
const getWebinars = () =>
  document.querySelectorAll(".webinars-ondemand-group .webinars-webinar");
const getAllFilter = () => document.querySelector("[data-filter='All']");
const getCheckboxes = () =>
  document.querySelectorAll(".webinars-sidenav-nav input");

const removeOtherOpenClasses = node => {
  const currentTitle = node.getAttribute("data-title");
  const otherHeaders = document.querySelectorAll(
    `.webinars-sidenav-block:not([data-title="${currentTitle}"])`
  );

  [...otherHeaders].forEach(node => node.classList.remove("open"));
};

const attachDropdownHandlers = () => {
  const sidenavBlocks = getSidenavBlocks();

  [...sidenavBlocks].forEach(block => {
    block.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();
      block.classList.toggle("open");

      if (e.target.getAttribute("data-title") == "Upcoming") {
        const upcomingGroup = document.querySelector(
          ".webinars-upcoming-group"
        );
        upcomingGroup.scrollIntoView();
        window.scrollBy(0, -80);
      }

      removeOtherOpenClasses(block);
    });
  });
};

const clearFilters = () => {
  const webinars = getWebinars();

  webinars.forEach(webinar => webinar.classList.remove("filtered"));
};

const checkAllFilter = () => (getAllFilter().checked = true);
const uncheckAllFilter = () => (getAllFilter().checked = false);

const filterWebinars = filters => {
  if (!filters.length) return;
  const webinars = getWebinars();

  webinars.forEach(webinar => {
    const category = webinar.getAttribute("data-category");

    if (!filters.includes(category)) {
      webinar.classList.add("filtered");
    }
  });
};

const uncheckAllBoxes = () => {
  const checkboxes = getCheckboxes();

  checkboxes.forEach(box => {
    const filter = box.getAttribute("data-filter");
    if (filter === "All") return;

    box.checked = false;
  });
};

const scrollAndCheckHeight = () => {
  const sidenav = document.querySelector(".webinars-sidenav-column");
  const eventsHeight = document.querySelector(".webinars-page").offsetHeight;
  const upcomingHeight = document.querySelector(".webinars-upcoming-group")
    .offsetHeight;
  const marginAndHeader = 220;

  // scroll to on-demand section
  window.scrollTo(0, upcomingHeight + marginAndHeader);

  sidenav.style.maxHeight = `${Math.min(300, eventsHeight)}px`;
};

const attachFilterEvents = () => {
  const checkboxes = document.querySelectorAll(".webinars-sidenav-nav__box");
  let filters = [];

  checkAllFilter();

  checkboxes.forEach(filterBox => {
    filterBox.addEventListener("click", e => {
      e.stopPropagation();
      clearFilters();
      const checkbox = e.currentTarget.querySelector("input");
      const filter = checkbox.getAttribute("data-filter");
      const allFilter = getAllFilter();
      // if the actual checkbox is clicked reverse default
      if (e.target.classList.contains("webinars-sidenav-list__item")) {
        checkbox.checked = !checkbox.checked;
      }

      if (filter === "All") {
        uncheckAllBoxes();
        filters = [];
        return checkAllFilter();
      }

      if (checkbox.checked) {
        let idx = filters.indexOf(filter);
        filters.splice(idx, 1);
        checkbox.checked = false;

        filterWebinars(filters);
        if (!filters.length) {
          checkAllFilter();
        }
        return;
      }

      uncheckAllFilter();
      checkbox.checked = true;

      filters.push(filter);

      filterWebinars(filters);

      if (window.matchMedia("(min-width: 62em)").matches) {
        scrollAndCheckHeight();
      }
    });
  });
};

const attachSidenavHandlers = () => {
  attachDropdownHandlers();
  attachFilterEvents();
};

const addFixedScrollEvent = () => {
  const container = document.querySelector(".webinars-sidenav-column");
  const footer = document.querySelector("#footer-navigation");
  const page = document.querySelector(".webinars-page");

  const margin = 120;

  window.addEventListener("scroll", () => {
    const containerHeight = Math.min(container.offsetHeight, page.offsetHeight);
    const footerHeight = footer.offsetHeight;
    const footerTop = document.body.offsetHeight - footerHeight;

    if (window.matchMedia("(min-width: 62em)").matches) {
      if (containerHeight + pageYOffset + margin > footerTop) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = `${(pageYOffset + margin - footerTop) *
          -1}px`;
      } else if (pageYOffset > 200) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = "300px";
      } else {
        container.style.position = "absolute";
        container.style.top = "0";
        container.style.maxHeight = `${Math.min(300, page.offsetHeight)}px`;
        document.body.overflowY = "auto";
      }
    }
  });
};

const addUpcomingAnalyticsAttr = () => {
  const upcoming = document.querySelector('[data-title="Upcoming"]');

  upcoming.setAttribute("href", "#upcoming");
  upcoming.setAttribute("data-analytics-handler", "body-link-click");
};

const hidePastUpcomingWebinars = () => {
  const upcomingGroup = document.querySelector(".webinars-upcoming-group");
  const upcomingNodes = upcomingGroup.querySelectorAll(".webinars-webinar");

  [...upcomingNodes].forEach(node => {
    const expiration = node.getAttribute("data-expiration");

    // Every wednesday upcoming webinar
    if (expiration == "") return;

    if (Date.now() > new Date(expiration)) node.classList.add("hide");
  });
};

const init = () => {
  attachSidenavHandlers();
  addFixedScrollEvent();
  addUpcomingAnalyticsAttr();
  plangridTrackEvents("webinars");
  hidePastUpcomingWebinars();
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/webinars.js